var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoBellBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "21px",
    viewBox: "0 0 16 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8219194B-FAE0-4236-AB1D-53F4D95140E3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.3337408,18.979574 C19.8553572,19.4579576 19.5330321,19.5 18.4166667,19.5 L7.58333321,19.5 C6.46696783,19.5 6.14464276,19.4579576 5.66625916,18.979574 C5.05914763,18.3724625 5.0876493,17.6029175 5.4583489,16.4940521 L6.49999986,12.8482738 L6.49999986,10.8333333 C6.49999986,6.08622872 8.98171905,3.25 13.0000581,3.25 C17.0183765,3.25 19.5000001,6.08620644 19.5000001,10.8333333 L19.5000001,12.8482738 L20.5353664,16.4720557 C20.9127016,17.6131457 20.9368148,18.3765 20.3337408,18.979574 Z M18.5351041,17.3331559 C18.5169918,17.2720708 18.4960931,17.205746 18.47226,17.1342467 L18.4583493,17.0892812 L17.3333335,13.1517262 L17.3333335,10.8333333 C17.3333335,7.22324145 15.7526169,5.41666667 13.0000581,5.41666667 C10.2474619,5.41666667 8.66666648,7.22327612 8.66666648,10.8333333 L8.66666648,13.1517262 L8.62498409,13.2976146 L7.52774001,17.1342467 C7.50390691,17.205746 7.48300817,17.2720708 7.46489592,17.3331559 C7.50124012,17.3332783 7.54059523,17.3333333 7.5833331,17.3333333 L18.4166669,17.3333333 C18.4594048,17.3333333 18.4987599,17.3332783 18.5351041,17.3331559 Z M9.20833308,20.5833333 L11.3749997,20.5833333 C11.3749997,21.4005122 11.7476159,21.6666667 12.9999997,21.6666667 C14.2523836,21.6666667 14.6249997,21.4005122 14.6249997,20.5833333 L16.7916664,20.5833333 C16.7916664,22.7840116 15.3226159,23.8333333 12.9999997,23.8333333 C10.6773836,23.8333333 9.20833308,22.7840116 9.20833308,20.5833333 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile",
    transform: "translate(-1574.000000, -25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_bell"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1569.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#191919",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBellBlack);
export default __webpack_public_path__ + "static/media/ico_bell_black.34da76c1c6ab0b6c939fa6819af4b687.svg";
export { ForwardRef as ReactComponent };